<template>
    <div>
        <div v-for="(cycle, index) in agreementCycles" :key="index"
            class="flex w-full p-3 shadow rounded-md gap-2"
            :class="{'opacity-40 cursor-not-allowed': isMyApraisal && !cycle.active}"
        >
            <Icon v-if="isMyApraisal" size="xs" icon-name="reviewicon" class-name="text-romanSilver self-start pt-1" />
            <div class="flex flex-col">
                <span class="font-black text-xs leading-5 tracking-wide text-blueCrayola uppercase">
                {{ cycle.name }}
                </span>
                <span class="font-bold text-sm flex leading-6 tracking-wide text-jet uppercase">
                {{
                    $DATEFORMAT(new Date(cycle.start), "MMMM dd, yyyy")
                }}
                -
                {{
                    $DATEFORMAT(new Date(cycle.end), "MMMM dd, yyyy")
                }}
                <span class="ml-4 flex" v-if="isMyApraisal && extendedCycle && extendedCycle.appraisalCycleId === cycle.id">
                    <p class="text-sm italic text-mediumSeaGreen uppercase" style="margin-top: 0.15rem">
                    Extended
                    </p>
                    <Icon icon-name="icon-info" size="xs" class="ml-3" style="margin-top: -0.15rem" />
                </span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "./Icon";

export default {
    name: 'PerformanceDetails',
    components: {
        Icon,
    },
    props: {
        agreementCycles: {
            type: Array,
            default: () => ([])
        },
        extendedCycle: {
            type: Object,
            default: () => ({})
        },
        isMyApraisal: {
            type: Boolean,
            default: false
        }
    },
}
</script>